import { Component, HostListener } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { SearchUiService } from '../services/search-ui.service';
import {
  filter
} from 'rxjs/operators';

@Component({
  selector: 'app-nav-header',
  standalone: false,
  templateUrl: './nav-header.component.html',
  styleUrl: './nav-header.component.css'
})
export class NavHeaderComponent {
  user: any;

  isEmpresas = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private searchUi: SearchUiService
  ) {

    this.authService.user$.subscribe(user => {
      this.user = user;
    });

  }

  ngOnInit(): void {

  this.user =
    this.authService.getUser();


  this.detectarTipo();


  this.router.events
    .pipe(
      filter(
        event =>
          event instanceof NavigationEnd
      )
    )
    .subscribe(() => {

      this.detectarTipo();

    });

}

  /**
   * Detecta si estamos navegando
   * en la sección Empresas.
   */
  detectarTipo(): void {

    this.isEmpresas =
      this.router.url.includes('/empresas') ||
      this.router.url.includes('seguros-corporativos');

  }

  /**
   * Cambia entre Personas y Empresas.
   */
  seleccionarTipo(tipo: 'personas' | 'empresas'): void {

    this.isEmpresas = tipo === 'empresas';

  }

  abrirBuscador(): void {
    this.searchUi.open();
  }

  salir(): void {

    this.authService.logout();

    this.router.navigate(['/login']).then(() => {

      setTimeout(() => {
        window.location.reload();
      }, 200);

    });

  }

}